import {createContext, use} from 'react'

/**
 * Shared "does this issue have sub-issues" truth so the sub-issues section and the body's
 * empty-state "Create sub-issue" button (exactly one shows) read one source instead of
 * disagreeing mid-mutation. Provided by the issue viewer when the optimistic overlay drives
 * the list; `undefined` means not provided, so consumers fall back to their own check.
 */
export const SubIssuesPresenceContext = createContext<boolean | undefined>(undefined)

export function useSubIssuesPresence(): boolean | undefined {
  return use(SubIssuesPresenceContext)
}
